module.exports = __webpack_public_path__ + "img/asuka.e8580eba.jpg";